import { EducationItem } from "./types";

const education: EducationItem[] = [
    {
        university: "National & Kapodistrian University of Athens",
        duration: "Oct 2016 - Feb 2021",
        description:
            "B.Sc. in Computer Science - Specializations: Software, Data & Knowledge Management.",
        location: "Athens, Greece",
        link: "https://www.di.uoa.gr/",
    },
];

export { education };
